import { canSize, IMAGE_WIDTHS, sizedImageUrl } from "../../../src/image-sizes";

/**
 * Responsive images. Shopify CDN URLs accept a `width` query, so one source becomes a 300/600/900
 * srcset; anything else (a data URI, another host) is served as is. Every image gets intrinsic
 * width/height (or sits in an aspect-ratio box) so nothing shifts when it loads.
 */
const WIDTHS = IMAGE_WIDTHS;

/**
 * Relay's own copies (`/media/…`, on nundi.co.za OR zsmerch.co.za, or relative) go through Cloudflare
 * Image Transformations. They are switched on for the nundi.co.za zone only, so image-sizes.ts always
 * rewrites to the nundi origin, even when the page is on zsmerch.co.za.
 */
const own = (url: string) => canSize(url, window.location.origin);

/** A `width`-wide version of the image where the host can make one; otherwise the original. */
export function sizedSrc(url: string, w: number): string {
  return sizedImageUrl(url, w, { base: window.location.origin });
}

export function Pic({ src, alt, sizes, eager, width = 600, height = 600, className }: {
  src: string; alt: string; sizes: string; eager?: boolean; width?: number; height?: number; className?: string;
}) {
  const cdn = own(src);
  return (
    <img
      className={className}
      src={cdn ? sizedSrc(src, 600) : src}
      srcSet={cdn ? WIDTHS.map((w) => `${sizedSrc(src, w)} ${w}w`).join(", ") : undefined}
      sizes={cdn ? sizes : undefined}
      alt={alt}
      width={width}
      height={height}
      loading={eager ? "eager" : "lazy"}
      decoding="async"
      fetchPriority={eager ? "high" : "auto"}
    />
  );
}
